const notificationsEn = {
    notifications: require('lang/en/notifications/Notifications').default,
};

export default notificationsEn;